"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WowLookupFetcherFactory = exports.GitHubWowLookupFetcher = void 0;
var wow_interface_1 = require("@wowlink/wow-interface");
var github_fetcher_1 = require("./builtin_fetchers/github_fetcher");
Object.defineProperty(exports, "GitHubWowLookupFetcher", { enumerable: true, get: function () { return github_fetcher_1.GitHubWowLookupFetcher; } });
var WowLookupFetcherFactory = function (type, config) {
    if (type == wow_interface_1.BuiltInLookupFetcherType.GitHub) {
        return new github_fetcher_1.GitHubWowLookupFetcher(config);
    }
    else {
        throw new Error("Lookup source " + type + " not supported.");
    }
};
exports.WowLookupFetcherFactory = WowLookupFetcherFactory;
